/**
 * Event Handler Class
 * namespace를 이용하여 특정 이벤트를 제거할 수 있다.
 */

import { _ } from 'core-js'

export default class EventHandler {
  static functionMap = {}

  /**
   * 이벤트 추가
   * @param {Object} elementOrWindows Element 또는 Window 객체들
   * @param {String} event 이벤트명
   * @param {Function} func 처리할 Callback 함수
   */
  static addEventListener (elementOrWindows, event, func) {
    if (!_.isArray(elementOrWindows) && !(elementOrWindows instanceof NodeList)) elementOrWindows = [elementOrWindows]

    for (let element of elementOrWindows) {
      EventHandler.functionMap[event] = func
      element.addEventListener(event.split('.')[0], EventHandler.functionMap[event])
    }
  }

  /**
   * 이벤트 제거
   * @param {Object} elementOrWindows Element 또는 Window 객체들
   * @param {String} event 이벤트명
   */
  static removeEventListener (elementOrWindows, event) {
    if (!_.isArray(elementOrWindows) && !(elementOrWindows instanceof NodeList)) elementOrWindows = [elementOrWindows]

    for (let element of elementOrWindows) {
      element.removeEventListener(event.split('.')[0], EventHandler.functionMap[event])
      delete EventHandler.functionMap[event]
    }
  }

  /**
   * 이벤트를 제거 한 후 추가(중복 이벤트를 방지하기 위함)
   * @param {Object} elementOrWindows Element 또는 Window 객체들
   * @param {String} event 이벤트명
   * @param {Function} func 처리할 Callback 함수
   */
  static removeAndAddEventListener (elementOrWindows, event, func) {
    if (!_.isArray(elementOrWindows) && !(elementOrWindows instanceof NodeList)) elementOrWindows = [elementOrWindows]

    for (let element of elementOrWindows) {
      this.removeEventListener(element, event, func)
      this.addEventListener(element, event, func)
    }
  }

  /**
   * 이벤트가 어느 Element에서 발생했는지 체크할 때 사용할 matches 객체 리턴
   */
  static matches = (function (doc) {
    return doc.matchesSelector ||
      doc.webkitMatchesSelector ||
      doc.mozMatchesSelector ||
      doc.oMatchesSelector ||
      doc.msMatchesSelector
  })(document.documentElement)
}

// const EventHandler = new EventHandlerClass()
